import styled from '@emotion/styled';
import { css } from '@emotion/core';
import UnstyledUploadIcon from '@material-ui/icons/Backup';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Error from '@material-ui/icons/Error';
import IconButton from '@material-ui/core/IconButton';
import COLORS from '$variables/colors';
import { spacing } from '$variables/theme';

export const Dropzone = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 96px;
  margin-top: ${spacing.medium};
  padding: ${spacing.xSmall};
  background: ${COLORS.grey2};
  border: 1px dashed ${COLORS.shadow2};
  border-radius: 4px;
  cursor: pointer;
  line-height: 16px;

  :focus {
    outline: none;
    border: 1px solid ${COLORS.greenDark};
  }

  ${({ hasFile }) => hasFile && `border: 1px solid ${COLORS.shadow2}`};
  ${({ isDragActive }) =>
    isDragActive && `border: 1px solid ${COLORS.greenDark}`};
  ${({ hasError }) => hasError && `border: 1px solid ${COLORS.errorRed}`};
`;

export const FakeLink = styled.span`
  color: ${COLORS.greenDark};
  :hover {
    text-decoration: underline;
  }
`;

export const DropzoneIcon = styled(UnstyledUploadIcon, {
  shouldForwardProp: (propName) => propName !== 'isDragActive',
})`
  width: 36px;
  height: 36px;
  color: ${COLORS.shadow5};

  ${Dropzone}:focus & {
    color: ${COLORS.greenDark};
  }
  ${({ isDragActive }) => isDragActive && `color: ${COLORS.greenDark}`};
`;

const iconStyle = css`
  width: 20px;
  height: 20px;
  margin-bottom: 10px;
`;

export const TickIcon = styled(CheckCircle)`
  ${iconStyle};
  color: ${COLORS.greenDark};
`;

export const ErrorIcon = styled(Error)`
  ${iconStyle};
  color: ${COLORS.errorRed};
`;

export const DropText = styled.div`
  color: ${COLORS.shadow5};
`;

export const DropTextSmall = styled(DropText)`
  font-size: 12px;
`;

export const RemoveButton = styled(IconButton)`
  position: absolute;
  top: 0;
  right: 0;
  margin: ${spacing.xSmall};
  height: 20px;
  width: 20px;
  color: ${COLORS.shadow5};
`;

export const Instructions = styled.div`
  margin-top: ${spacing.medium};
  text-align: center;
`;
